import { VFC } from 'react'

import { useTranslation } from 'react-i18n-lite'
import { useTasks } from 'task/List/hooks'
import { TaskAction } from 'task/shared/components'

const List: VFC = (): JSX.Element => {
  const { t } = useTranslation()

  const tasks = useTasks()

  return (
    <div style={{ padding: '20px' }}>
      <h2>{t('task.list-title')}</h2>
      <ul>
        {tasks?.map((task) => {
          if (!task.taskmodel || !task.workflow) {
            return null
          }

          return (
            <TaskAction
              key={task.uuid}
              taskmodel={task.taskmodel}
              workflowUuid={task.workflow?.uuid}
              dataContainer={task.workflow?.state?.data_container}
              withWorkflowLink
            />
          )
        })}
      </ul>
    </div>
  )
}

export default List
